module.exports = __webpack_public_path__ + "BuckConfused-bace2a7f60716793b2d7befcae1e0180.svg";